export const COLUMN_KEY = {
  TOPIC: 'deTai',
  CRITERIA: 'tieuChi',
}

export const CATEGORY_PATH = {
  [COLUMN_KEY.TOPIC]: "document-topic",
  [COLUMN_KEY.CRITERIA]: "criteria",
}

export enum CRITERIA_TYPE {
  PHAN = 1,
  CHUONG = 2,
  TIEU_CHI = 3,
  TIEU_MUC = 4,
}

export const CRITERIA_TYPE_NAME = {
  [CRITERIA_TYPE.CHUONG]: "Chương",
  [CRITERIA_TYPE.PHAN]: "Phần",
  [CRITERIA_TYPE.TIEU_CHI]: "Tiêu chí",
  [CRITERIA_TYPE.TIEU_MUC]: "Tiểu mục",
}
